<template>
  <div class="md-layout overflow-x-hidden">
    <div class="md-layout-item md-size-100 pl-0">
      <label
        class="
          md-layout-item md-size-100 md-small-size-100
          text-base
          font-medium
          pt-4
          required
          pr-0
        "
      >
        {{ $t("communication.choose_recipient") }}</label
      ><span class="text-red-600"> *</span>
      <div class="md-layout-item md-size-100 h-20">
        <Recipient
          label="common.student"
          value="student"
          :filterList="STUDENT_LIST"
          :recipientFilterProps="choose_recipient.student"
          :settingProps="recipient.student"
          ref="studentSetting"
          @checkRecipient="checkRecipient"
        >
        </Recipient>
      </div>
      <div class="md-layout-item md-size-100 h-20">
        <Recipient
          label="common.family"
          value="family"
          :filterList="FAMILY_LIST"
          :recipientFilterProps="choose_recipient.family"
          :settingProps="recipient.family"
          ref="familySetting"
          @checkRecipient="checkRecipient"
        >
        </Recipient>
      </div>
      <div class="md-layout-item md-size-100 h-20">
        <Recipient
          label="common.teacher"
          value="teacher"
          :filterList="TEACHER_LIST"
          :recipientFilterProps="choose_recipient.teacher"
          :settingProps="recipient.teacher"
          ref="teacherSetting"
          @checkRecipient="checkRecipient"
        >
        </Recipient>
      </div>
      <div class="md-layout-item md-size-100 h-20">
        <Recipient
          label="survey.other_staff"
          value="other_staffs"
          :recipientFilterProps="choose_recipient.other_staffs"
          :settingProps="recipient.other_staffs"
          ref="otherSetting"
          @checkRecipient="checkRecipient"
        >
        </Recipient>
      </div>
      <div class="md-layout-item md-size-100">
        <span class="text-[#ff1744] text-sm" v-if="recipientedRequire">
          {{ $t("communication.recipient_require") }}
        </span>
      </div>
    </div>
    <div class="md-layout-item md-size-100 pl-0 md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field>
          <label>{{ $t("communication.template_type") }}</label>
          <md-select name="typeTemplate" v-model="templateSelected">
            <md-option
              v-for="(item, idx) in templateSms"
              :value="getId(item)"
              :key="'type' + idx"
              >{{ $t(item.name) }} - {{ $t(item.type) }}</md-option
            >
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <validation-field name="title">
          <label>{{ $t("communication.title") }}</label>
          <md-input v-model="title"></md-input>
        </validation-field>
      </div>
      <div class="editor-block">
        <p class="text-right text-sm -mb-2">
          {{ content.length }}
          {{ $t("communication.characters") }}
        </p>
        <validation-field :validations="smsValidation.contents" name="content">
          <md-textarea
            v-model="content"
            class="relative bg-[#ffffff00] z-10"
          ></md-textarea>
          <span v-if="!content" class="place-holder" data-text=" *">{{
            $t("communication.please_enter_content")
          }}</span>
        </validation-field>
      </div>
    </div>
  </div>
</template>

<script>
import Recipient from "./Recipient.vue";
import { dataRecipient } from "./Recipient.js";
import { STUDENT_LIST, FAMILY_LIST, TEACHER_LIST } from "./index.js";
import { service_names, service_paths } from "@/constants/Services";
import { Message, getId } from "@/helpers/utils";
import { validations } from "@/validations/communication";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: { Recipient },
  mixins: [dataRecipient],
  data() {
    return {
      STUDENT_LIST,
      FAMILY_LIST,
      TEACHER_LIST,
      smsValidation: validations,
      templateSelected: null,
      templateSms: [],
      recipientedCount: null,
      recipient: {
        student: null,
        family: null,
        teacher: null,
        other_staffs: null
      },
      recipientedRequire: false,
      getId,
      // data server
      choose_recipient: {},
      title: null,
      content: ""
    };
  },
  created() {
    this.getTemplatesSms();
  },
  watch: {
    templateSelected: function(template) {
      this.selectTemplate(template);
    }
  },
  methods: {
    getDataRecipient() {
      this.recipient = this.renderRecipient("recSetting");
      this.choose_recipient = cloneDeep(
        this.renderRecipient("recipientFilter")
      );
    },
    renderRecipient(recipient) {
      return {
        student: this.$refs.studentSetting[recipient],
        family: this.$refs.familySetting[recipient],
        teacher: this.$refs.teacherSetting[recipient],
        other_staffs: this.$refs.otherSetting[recipient]
      };
    },
    checkRecipient(recipientedCheck) {
      if (recipientedCheck !== null) {
        this.recipientedCount++;
      } else {
        this.recipientedCount--;
      }
    },
    validateRecipient() {
      if (this.recipientedCount < 1) {
        this.recipientedRequire = true;
      } else {
        this.recipientedRequire = false;
        this.sendSms();
      }
    },
    formatDataSms() {
      for (let item in this.recipient) {
        if (this.recipient[item] === null) {
          delete this.choose_recipient[item];
        }
      }
      if (this.choose_recipient.student?.filter === "student") {
        delete this.choose_recipient.student.status;
        this.choose_recipient.student.filter = "user";
      }
      if (
        this.choose_recipient.family?.filter === "student" ||
        this.choose_recipient.family?.filter === "parent"
      ) {
        delete this.choose_recipient.family.status;
        this.choose_recipient.family?.filter === "student"
          ? (this.choose_recipient.family.filter = "user")
          : (this.choose_recipient.family.filter = "family");
      }
      if (this.choose_recipient.teacher?.filter === "teacher") {
        delete this.choose_recipient.teacher.status;
        this.choose_recipient.teacher.filter = "user";
      }
    },
    getTemplatesSms() {
      this.$axios
        .get(service_paths.communication_template, { limit: 999 })
        .then(res => {
          res.data.data.map(template => {
            if (template.type === "sms") this.templateSms.push(template);
          });
        });
    },
    selectTemplate(template) {
      const templateData = this.templateSms.find(
        item => getId(item) == template
      );
      this.title = templateData.title;
      this.content = templateData.content;
    },
    async sendSms() {
      this.getDataRecipient();
      this.formatDataSms();
      const dataSms = {
        title: this.title,
        content: this.content,
        choose_recipient: this.choose_recipient,
        provider_id: 1
      };
      await this.$axios.post(
        `${service_names.school}/sms-participant`,
        dataSms
      );
      Message.success(this.$t("common.send_success"));
      this.$emit("sendSuccess");
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-block {
  width: 100%;
  padding: 15px;
  box-sizing: content-box;
  .md-field {
    display: block !important;
  }
  textarea {
    width: 100%;
    border: 1px solid #c7c7c7;
    border-radius: 2px;
    font-size: 14px;
    min-height: 120px;
    padding: 10px;
  }
  .tox-tinymce {
    width: 100%;
  }
}
::v-deep .editor-block .md-field .md-error {
  position: initial;
  padding-top: 8px;
}
.place-holder {
  position: absolute;
  left: 0;
  top: 0;
  padding: 19px 0 0 17px;
  font-size: 14px;
}
</style>
